import * as THREE from 'three';
import React, { useState, useMemo } from 'react'
import { const_var, params } from '../../../../../../redux/reducers/reducer'
import { delModel, extrudeSettings, jTrimModel, textureAnisotropy, wainscotTrimModel } from '../../../../../../utils/Functions';
import { CSG } from '../../../../../../assets/libs/csg-lib';
import { useDispatch, useSelector } from 'react-redux';
import { setWallCloseStateWrap } from '../../../../../../action';
import { MaterialTrim, MaterialWainScotTrim, MaterialWainScotTrimNew } from '../../../../CustomMaterial';
import { useThree } from '@react-three/fiber';

const TrimModel = () => {
    const dispatch = useDispatch();
    const { gl } = useThree();
    const wallCloseStateWrap = useSelector(state => state.reducer.wallCloseStateWrap)
    
    const [wallCloseState, setWallCloseState] = useState(0);

    const leftTrimModel = useMemo(() => {
        const model = new THREE.Shape();

        let overHeight = 0;
        if (params.p_r_s === 1) {
            overHeight = 0;
        } else {
            overHeight = -0.1
        }

        if((params.leanStyle.right === 'standard') && ((params.add_right_lean && params.leantoAlignmentRight == 2 && !(params.p_f_w === 'Open') && !(params.p_b_c_b_r_f === 'Open'))  || (params.add_right_lean && (params.leantoAlignmentRight == 1 || params.leantoAlignmentRight == 3) && params.p_d === params.leanR_p_d && !(params.p_f_w === 'Open') && !(params.p_b_c_b_r_f === 'Open')) || (params.p_f_w === 'Open' && params.cB_addStorage_check_right && !params.singleSlope && params.p_b_c_b_r_f !== 'Open'))){
            if (wallCloseState > -1) {
                model.moveTo(-(params.p_d / 2 + 0.26), params.leanR_p_h + params.leanR_p_w * params.b_l_t_r_pR / 12 + (params.p_r_s === 1 ? const_var.roofRegularDst * 2 : -0.2));
                model.lineTo(-(params.p_d / 2 + 0.26), (params.singleSlope && params.freeStandingSide === "right") ? params.p_h - ((params.p_r_p / 12) * params.p_w) + overHeight : params.p_h + overHeight);
                model.lineTo(-(params.p_d / 2 + 0.03), (params.singleSlope && params.freeStandingSide === "right") ? params.p_h - ((params.p_r_p / 12) * params.p_w) + overHeight : params.p_h + overHeight);
                model.lineTo(-(params.p_d / 2 + 0.03), params.leanR_p_h + params.leanR_p_w * params.b_l_t_r_pR / 12 + (params.p_r_s === 1 ? const_var.roofRegularDst * 2 : -0.2));
                model.closePath();
            } 
        } else if((params.leanStyle.right !== 'standard') && ((params.add_right_lean && params.leantoAlignmentRight == 2 && !(params.p_f_w === 'Open') && (params.p_b_c_b_r !== 'Open' || (params.add_storage_check_right && params.rightLeanStoragePosition === 0)))  || (params.add_right_lean && (params.leantoAlignmentRight !==2) && params.p_d === params.leanR_p_w && !(params.p_f_w === 'Open') && (params.p_b_c_b_r !== 'Open' || (params.add_storage_check_right && params.rightLeanStoragePosition === 0))) || (params.p_f_w === 'Open' && params.cB_addStorage_check_right && !params.singleSlope && (params.p_b_c_b_r !== 'Open' || (params.add_storage_check_right && params.rightLeanStoragePosition === 0))))){
            
            if (params.add_storage_check_right && params.rightLeanStoragePosition === 0) {
                model.moveTo(-(params.p_d / 2 + 0.26), params.leanR_p_h + (params.p_r_s === 1 ? const_var.roofRegularDst * 2 : -0.2));
                model.lineTo(-(params.p_d / 2 + 0.26), (params.singleSlope && params.freeStandingSide === "right") ? params.p_h - ((params.p_r_p / 12) * params.p_w) + overHeight : params.p_h + overHeight);
                model.lineTo(-(params.p_d / 2 + 0.03), (params.singleSlope && params.freeStandingSide === "right") ? params.p_h - ((params.p_r_p / 12) * params.p_w) + overHeight : params.p_h + overHeight);
                model.lineTo(-(params.p_d / 2 + 0.03), params.leanR_p_h + (params.p_r_s === 1 ? const_var.roofRegularDst * 2 : -0.2));
                model.closePath();
            } else if (wallCloseState > -1) {
                model.moveTo(-(params.p_d / 2 + 0.26), wallCloseStateWrap.RLLeftWallCloseState + 0.1);
                model.lineTo(-(params.p_d / 2 + 0.26), wallCloseState);
                model.lineTo(-(params.p_d / 2 + 0.03), wallCloseState);
                model.lineTo(-(params.p_d / 2 + 0.03), wallCloseStateWrap.RLLeftWallCloseState + 0.1);
                model.closePath();
            }
        } else {
            if (wallCloseState > -1) {
                model.moveTo(-(params.p_d / 2 + 0.26), wallCloseState);
                model.lineTo(-(params.p_d / 2 + 0.26), (params.singleSlope && params.freeStandingSide === "right") ? params.p_h + ((params.p_r_p / 12) * params.p_w) + overHeight : params.p_h + overHeight);
                model.lineTo(-(params.p_d / 2 + 0.03), (params.singleSlope && params.freeStandingSide === "right") ? params.p_h + ((params.p_r_p / 12) * params.p_w) + overHeight : params.p_h + overHeight);
                model.lineTo(-(params.p_d / 2 + 0.03), wallCloseState);
                model.closePath();
            }
        }

        return model;
    
    }, [params.p_h, params.p_w, params.p_r_p, wallCloseState, params.p_d, params.p_r_s, params.singleSlope, params.leanR_p_h, params.b_l_t_r_pR, params.add_right_lean, params.leanR_p_w, params.leantoAlignmentRight, params.p_d, params.leanR_p_d, params.p_f_w, params.p_b_c_b_r_f, params.cB_addStorage_check_right, params.freeStandingSide, params.add_storage_check_right, params.rightLeanStoragePosition])

    const rightTrimModel = useMemo(() => {
        const model = new THREE.Shape();

        let overHeight = 0;
        if (params.p_r_s === 1) {
            overHeight = 0;
        } else {
            overHeight = -0.1
        }

        if((params.leanStyle.right === 'standard') && ((params.add_right_lean && params.leantoAlignmentRight == 3 && !(params.p_b_w === 'Open') && !(params.p_b_c_b_r_b === 'Open'))  || (params.add_right_lean && params.leantoAlignmentRight == 1 && params.p_d === params.leanR_p_d && !(params.p_b_w === 'Open') && !(params.p_b_c_b_r_b === 'Open')) || (params.p_b_w === 'Open' && params.cB_addStorage_check_right && !params.singleSlope && params.p_b_c_b_r_f !== 'Open'))){
            if (wallCloseState > -1) {
                model.moveTo((params.p_d / 2 + 0.26), params.leanR_p_h + params.leanR_p_w * params.b_l_t_r_pR / 12 + (params.p_r_s === 1 ? const_var.roofRegularDst * 2 : -0.2));
                model.lineTo((params.p_d / 2 + 0.26), (params.singleSlope && params.freeStandingSide === "right") ? params.p_h - ((params.p_r_p / 12) * params.p_w) + overHeight : params.p_h + overHeight);
                model.lineTo((params.p_d / 2 + 0.03), (params.singleSlope && params.freeStandingSide === "right") ? params.p_h - ((params.p_r_p / 12) * params.p_w) + overHeight : params.p_h + overHeight);
                model.lineTo((params.p_d / 2 + 0.03), params.leanR_p_h + params.leanR_p_w * params.b_l_t_r_pR / 12 + (params.p_r_s === 1 ? const_var.roofRegularDst * 2 : -0.2));
                model.closePath();
            } 
        } else if((params.leanStyle.right !== 'standard') && ((params.add_right_lean && params.leantoAlignmentRight == 3 && !(params.p_b_w === 'Open') && (!(params.p_b_c_b_r_r === 'Open') || params.add_storage_check_right))  || (params.add_right_lean && params.leantoAlignmentRight == 1 && params.p_d === params.leanR_p_w && !(params.p_b_w === 'Open') && (!(params.p_b_c_b_r_r === 'Open') || params.add_storage_check_right)) || (params.p_b_w === 'Open' && params.cB_addStorage_check_right && !params.singleSlope && params.p_b_c_b_r !== 'Open'))){
                model.moveTo((params.p_d / 2 + 0.26), params.leanR_p_h + (params.p_r_s === 1 ? const_var.roofRegularDst * 2 : -0.2));
                model.lineTo((params.p_d / 2 + 0.26), (params.singleSlope && params.freeStandingSide === "right") ? params.p_h - ((params.p_r_p / 12) * params.p_w) + overHeight : params.p_h + overHeight);
                model.lineTo((params.p_d / 2 + 0.03), (params.singleSlope && params.freeStandingSide === "right") ? params.p_h - ((params.p_r_p / 12) * params.p_w) + overHeight : params.p_h + overHeight);
                model.lineTo((params.p_d / 2 + 0.03), params.leanR_p_h + (params.p_r_s === 1 ? const_var.roofRegularDst * 2 : -0.2));
                model.closePath();
        } else {
            if (wallCloseState > -1) {
                model.moveTo(params.p_d / 2 + 0.03, wallCloseState);
                model.lineTo(params.p_d / 2 + 0.03, (params.singleSlope && params.freeStandingSide === "right") ? params.p_h + ((params.p_r_p / 12) * params.p_w) + overHeight : params.p_h + overHeight);
                model.lineTo(params.p_d / 2 + 0.26, (params.singleSlope && params.freeStandingSide === "right") ? params.p_h + ((params.p_r_p / 12) * params.p_w) + overHeight : params.p_h + overHeight);
                model.lineTo(params.p_d / 2 + 0.26, wallCloseState);
                model.closePath();
            }
        }

        return model;
    
    }, [params.p_h, params.p_w, params.p_r_p, wallCloseState, params.p_d, params.p_r_s, params.singleSlope, params.leanR_p_h, params.b_l_t_r_pR, params.add_right_lean, params.leanR_p_w, params.leantoAlignmentRight, params.p_d, params.leanR_p_d, params.p_b_w, params.p_b_c_b_r_b, params.p_b_c_b_r, params.p_b_c_b_r_r, params.cB_addStorage_check_right, params.freeStandingSide])
    
    const rightLeanFrontTrimModel = useMemo(() => {
        const model = new THREE.Shape();
        if((params.leanR_p_d === params.p_d || params.leantoAlignmentRight === 2) && wallCloseStateWrap.RLFrontWallCloseState !== undefined){
            model.moveTo(-(params.p_d / 2 + 0.26), wallCloseStateWrap.RLFrontWallCloseState);
            model.lineTo(-(params.p_d / 2 + 0.26), params.p_h) 
            model.lineTo(-(params.p_d / 2 + 0.03), params.p_h)
            model.lineTo(-(params.p_d / 2 + 0.03), wallCloseStateWrap.RLFrontWallCloseState);
            model.closePath();
        }
        return model;
    
    }, [params.p_h, params.p_d, wallCloseStateWrap.RLFrontWallCloseState, params.leanR_p_d, params.leantoAlignmentRight])

    const rightLeanBackTrimModel = useMemo(() => {
        const model = new THREE.Shape();
        if((params.leanR_p_d === params.p_d || params.leantoAlignmentRight === 3) && wallCloseStateWrap.RLBackWallCloseState !== undefined){
        model.moveTo(params.p_d / 2 + 0.03, wallCloseStateWrap.RLBackWallCloseState);
        model.lineTo(params.p_d / 2 + 0.03, params.p_h) 
        model.lineTo(params.p_d / 2 + 0.26, params.p_h)
        model.lineTo(params.p_d / 2 + 0.26, wallCloseStateWrap.RLBackWallCloseState);
        model.closePath();
        }
        return model;
    
    }, [params.p_h, params.p_d, wallCloseStateWrap.RLBackWallCloseState, params.leanR_p_d, params.leantoAlignmentRight])

    const connectLeftTrimModel = useMemo(() => {
        const model = new THREE.Shape();
        if(wallCloseStateWrap.RLFrontWallCloseState !== undefined){
            if(params.add_right_lean && params.p_f_w === 'Open' && params.cB_addStorage_check_right && params.p_b_c_b_r_f !== 'Open' && params.p_b_c_b_r_f !== 'Close' && (params.leanR_p_d === params.p_d || params.leantoAlignmentRight === 2)){
                model.moveTo(-(params.p_d / 2 + 0.26), 0);
                model.lineTo(-(params.p_d / 2 + 0.26), wallCloseStateWrap.RLFrontWallCloseState);
                model.lineTo(-(params.p_d / 2 + 0.03), wallCloseStateWrap.RLFrontWallCloseState);
                model.lineTo(-(params.p_d / 2 + 0.03), 0);
                model.closePath();
            }  
        }
        return model;
    
    }, [params.p_d,  params.leantoAlignmentRight, wallCloseStateWrap.RLFrontWallCloseState, params.add_right_lean, params.cB_addStorage_check_right, params.p_b_c_b_r_f, params.leanR_p_d, params.p_f_w])

    const connectRightTrimModel = useMemo(() => {
        const model = new THREE.Shape();
        if(wallCloseStateWrap.RLBackWallCloseState !== undefined){
            if(params.add_right_lean && params.p_b_w === 'Open' && params.cB_addStorage_check_right && params.p_b_c_b_l_b !== 'Open' && params.p_b_c_b_l_b !== 'Close' && (params.leanR_p_d === params.p_d || params.leantoAlignmentRight === 3)){
                model.moveTo((params.p_d / 2 + 0.26), 0);
                model.lineTo((params.p_d / 2 + 0.26), wallCloseStateWrap.RLBackWallCloseState);
                model.lineTo((params.p_d / 2 + 0.03), wallCloseStateWrap.RLBackWallCloseState);
                model.lineTo((params.p_d / 2 + 0.03), 0);
                model.closePath();
            }  
        }
        return model;
    
    }, [params.p_d,  params.leantoAlignmentRight, wallCloseStateWrap.RLBackWallCloseState, params.add_right_lean, params.cB_addStorage_check_right, params.p_b_c_b_l_b, params.leanR_p_d, params.p_b_w])
    
    const backStorageWallModel = useMemo(() => {
        const model = new THREE.Shape();
        model.moveTo(-params.p_d / 2 - 0.1, 0);
        model.lineTo(-params.p_d / 2 - 0.1, params.p_h) 
        model.lineTo(-params.p_d / 2 + parseInt(params.p_u_t) + 0.05, params.p_h)
        model.lineTo(-params.p_d / 2 + parseInt(params.p_u_t) + 0.05, 0);
        model.closePath();

        return model;
    
    }, [params.p_h, params.p_d, params.p_u_t])

    const mainTrimModel = useMemo(() => {
        const meshJTrimModel = new THREE.Mesh(new THREE.ExtrudeGeometry(jTrimModel(0.15, 0.2), extrudeSettings(params.p_d)), new THREE.MeshStandardMaterial({ color: 'red' }))
        const meshStorageDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(backStorageWallModel, extrudeSettings(1)), new THREE.MeshStandardMaterial({ color: 'red' }))
        const meshDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('right', 'wall'), extrudeSettings(1)), new THREE.MeshStandardMaterial({ color: 'red' }))
    
        const meshJTrimModel_Temp = meshJTrimModel.clone();
        meshJTrimModel_Temp.rotation.y = -Math.PI/2
        meshJTrimModel_Temp.position.set((params.p_d / 2), wallCloseState + 0.1, (params.p_w / 2) - 0.0075);
        meshJTrimModel_Temp.updateMatrixWorld();

        const meshStroageDelModel_Temp = meshStorageDelModel.clone();
        meshStroageDelModel_Temp.rotation.y = Math.PI
        meshStroageDelModel_Temp.position.set(-params.endStoragePositionZ - 0.1, 0, (params.p_w / 2 - 0.0025 + 0.5));
        meshStroageDelModel_Temp.updateMatrixWorld();
    
        const meshDelModel_Temp = meshDelModel.clone();
        meshDelModel_Temp.rotateY(Math.PI)
        meshDelModel_Temp.position.set(0, 0, params.p_w / 2 + 0.5);
        meshDelModel_Temp.updateMatrixWorld();
    
        const meshJTrimModel_CSG = CSG.fromMesh(meshJTrimModel_Temp);
        const meshStorageDelModel_CSG = CSG.fromMesh(meshStroageDelModel_Temp);
        const meshDelModel_CSG = CSG.fromMesh(meshDelModel_Temp);
    
        let JtrimStorageDelModel_CSG;
        const JTrimModel_CSG = meshJTrimModel_CSG.subtract(meshDelModel_CSG);
        if(params.p_u_c) JtrimStorageDelModel_CSG = JTrimModel_CSG.subtract(meshStorageDelModel_CSG);
        else JtrimStorageDelModel_CSG = JTrimModel_CSG
        
        const CSGJTrimModel = CSG.toMesh(
            JtrimStorageDelModel_CSG,
            new THREE.Matrix4()
        )
    
        /**********************cutting hole using CSG for Wainscot Trim************************/
    
        const meshWainscotTrimModel = new THREE.Mesh(new THREE.ExtrudeGeometry(wainscotTrimModel(0.14, 0.17), extrudeSettings(params.p_d + 0.35)), new THREE.MeshStandardMaterial({ color: 'red' }))
        const meshWainscotDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('right', 'wall'), extrudeSettings(1)), new THREE.MeshStandardMaterial({ color: 'blue' }))
    
        const meshWainscotTrimModel_Temp = meshWainscotTrimModel.clone();
        meshWainscotTrimModel_Temp.rotation.y = Math.PI/-2
        meshWainscotTrimModel_Temp.position.set((params.p_d / 2 + 0.15), 3, (params.p_w / 2));
        meshWainscotTrimModel_Temp.updateMatrixWorld();
    
        const meshWainscotDelModel_Temp = meshWainscotDelModel.clone();
        meshWainscotDelModel_Temp.rotateY(Math.PI)
        meshWainscotDelModel_Temp.position.set(0, 0, params.p_w / 2 + 0.5);
        meshWainscotDelModel_Temp.updateMatrixWorld();
    
        const meshWainscotTrimModel_CSG = CSG.fromMesh(meshWainscotTrimModel_Temp);
        const meshWainscotDelModel_CSG = CSG.fromMesh(meshWainscotDelModel_Temp);
    
        const wainscotTrimModel_CSG = meshWainscotTrimModel_CSG.subtract(meshWainscotDelModel_CSG);
        const CSGWainscotTrimModel = CSG.toMesh(
            wainscotTrimModel_CSG,
            new THREE.Matrix4()
        )

        // setCSGJTrimModelGeometry(CSGJTrimModel.geometry);
        // setCSGwainscotTrimModelGeometry(CSGWainscotTrimModel.geometry);

        return {
            jTrim: CSGJTrimModel.geometry,
            wTrim: CSGWainscotTrimModel.geometry
        }
        
    }, [params.p_d, params.p_w, params.p_u_c, params.p_u_t, params.p_r_w, const_var.newDoorsArray, wallCloseState, params.endStoragePositionZ]);

    useMemo(() => {
        var wallCloseValue = 0;
        var tempCutState = 0;
        let leanHeightValue = -1;
        let finalHeight = (params.singleSlope && params.freeStandingSide === "right") ? params.p_h + ((params.p_r_p / 12) * params.p_w) : params.p_h

        if (params.p_r_w === 'Open') {
            wallCloseValue = 0;
        } else if (params.p_r_w === "One_Fourth_Close") {
            wallCloseValue = (finalHeight * 3) / 4;
        } else if (params.p_r_w === "Half_Close") {
            wallCloseValue = finalHeight / 2;
        } else if (params.p_r_w === "Three_Fourth_Close") {
            wallCloseValue = finalHeight / 4;
        } else if (params.p_r_w === "Close") {
            wallCloseValue = 0;
        } else {
            wallCloseValue = finalHeight - (3 * params.p_r_w) - 0.2;
        }
        if (params.p_c_p_r) {
            if (params.p_r_w === 'Open') {
                tempCutState = finalHeight - 1.5;
            } else {
                tempCutState = wallCloseValue - 1.5;
            }
        } else {
            tempCutState = wallCloseValue;
        }

        if (params.add_right_lean) {
                let leanFinalHeight = params.p_h - (params.leanR_p_h + (params.leanStyle.right === "gable" ? 0 : (parseInt(params.b_l_t_r_pR) / 12 * params.leanR_p_w)));
    
                if(params.add_right_lean && leanFinalHeight > 0 &&  (Math.abs(params.p_r_w) * 3) -leanFinalHeight < 3)
                {    
                    let wH = leanFinalHeight+0.2;
                    tempCutState = params.p_h - wH + (params.p_r_s === 1 && const_var.roofRegularDst * 2);
                } else {
                    if(isNaN(params.p_r_w) == false){
                        let wH = (3 * params.p_r_w) - 0.2;
                        tempCutState = finalHeight - wH + (params.p_r_s === 1 && const_var.roofRegularDst * 2);
                    }else if(params.p_r_w === 'Open' && params.p_c_p_r){
                        tempCutState = params.p_h
                    }   
                }
                if(tempCutState == 0 && params.p_r_w === 'Open') tempCutState = -1; 
                if (params.p_c_p_r) {
                    if (params.p_r_w === 'Open'){
                        setWallCloseState(tempCutState);
                        dispatch(setWallCloseStateWrap({'cbRightWallCloseState': tempCutState}))
                    }else{
                        setWallCloseState(tempCutState - 1.5);
                        dispatch(setWallCloseStateWrap({'cbRightWallCloseState': tempCutState - 1.5}));
                    }
                }else{
                    setWallCloseState(tempCutState);
                    dispatch(setWallCloseStateWrap({'cbRightWallCloseState': tempCutState}))
                }

        } else {
            /** cutting panel options isn't disabled when wall close state over limit */
            if (tempCutState > 0) {
                setWallCloseState(tempCutState);
                dispatch(setWallCloseStateWrap({'cbRightWallCloseState': tempCutState}))
            } else {
                if (params.p_r_w === 'Open') {
                    setWallCloseState(-1);
                    dispatch(setWallCloseStateWrap({'cbRightWallCloseState': -1}))
                } else {
                    setWallCloseState(0);
                    dispatch(setWallCloseStateWrap({'cbRightWallCloseState': 0}))
                }
            }
        }

    
    }, [params.p_w, params.p_r_w, params.p_c_p_r, params.p_h, params.p_r_p, params.p_r_s, params.add_right_lean, params.leanR_p_h, params.leanR_p_w, params.b_l_t_r_pR])

     

    return (
        <group name='trim-group' rotation={[0, Math.PI / 2, 0]}>
            <mesh name="right-left-trim" position={[0.03, 0, params.p_w / 2 - 0.15]}>
                <extrudeGeometry args={[leftTrimModel, extrudeSettings(0.225)]} />
                <MaterialTrim visibleSection={"center"} />
            </mesh>
            <mesh name="right-right-trim" position={[-0.03, 0, params.p_w / 2 - 0.15]}>
                <extrudeGeometry args={[rightTrimModel, extrudeSettings(0.225)]} />
                <MaterialTrim visibleSection={"center"} />
            </mesh>

            {params.leanStyle.right !== "gable" && params.p_f_w === 'Open' && params.p_b_c_b_r_f !== 'Open' && params.add_right_lean && (!params.cB_addStorage_check_left && !params.cB_addStorage_check_right) &&
                <mesh name="right-lean-front-trim" position={[0.03, 0, params.p_w / 2 - 0.15]}>
                    <extrudeGeometry args={[rightLeanFrontTrimModel, extrudeSettings(0.225)]} />
                    <MaterialTrim visibleSection={"center"} />
                </mesh>
            }
            {params.leanStyle.right !== "gable" && params.p_b_w === 'Open' && params.p_b_c_b_r_b !== 'Open' && params.add_right_lean && (!params.cB_addStorage_check_left && !params.cB_addStorage_check_right) &&
                <mesh name="right-lean-back-trim" position={[-0.03, 0, params.p_w / 2 - 0.15]}>
                    <extrudeGeometry args={[rightLeanBackTrimModel, extrudeSettings(0.225)]} />
                    <MaterialTrim visibleSection={"center"} />
                </mesh>
            }

            <mesh name="left-connect-trim" position={[0, 0, params.p_w/ 2 - 0.15]}>
                <extrudeGeometry args={[connectLeftTrimModel, extrudeSettings(0.2)]} />
                <MaterialTrim visibleSection={"center"} />
            </mesh>
            <mesh name="right-connect-trim" position={[0, 0, params.p_w / 2 - 0.15]}>
                <extrudeGeometry args={[connectRightTrimModel, extrudeSettings(0.2)]} />
                <MaterialTrim visibleSection={"center"} />
            </mesh>

            {params.p_r_w !== 'Open' && params.p_r_w !== 'Close' && params.p_j_t && mainTrimModel.jTrim && (
                <mesh name="right-horizontal-trim" geometry={mainTrimModel.jTrim} >
                    <MaterialTrim visibleSection={"center"} />
                </mesh>
            )}
            {params.p_c_p_r == true && params.p_j_t && mainTrimModel.jTrim && (
                <mesh name="right-horizontal-trim" geometry={mainTrimModel.jTrim} >
                    <MaterialTrim visibleSection={"center"} />
                </mesh>
            )}

            {(params.p_w_c_n === true && params.p_r_w === "Close") && mainTrimModel.wTrim && (
                <mesh name="right_leg_wainscotRightTrim" geometry={mainTrimModel.wTrim}>
                    <MaterialWainScotTrimNew visibleSection={"center"}  />
                </mesh>
            )}
        </group>
    )
}

export default TrimModel